const translationMap = new Map();
let loaded = false;
export function loadTranslations(entries) {
    translationMap.clear();
    for (const entry of entries) {
        const key = `${entry.language.toLowerCase()}:${entry.term.toLowerCase()}`;
        translationMap.set(key, entry.canonicalEnglish);
    }
    loaded = true;
}
export function translateTerm(term, language) {
    if (language === 'en')
        return term;
    const key = `${language.toLowerCase()}:${term.toLowerCase()}`;
    return translationMap.get(key) ?? term;
}
export function isLoaded() {
    return loaded;
}
export function clearTranslations() {
    translationMap.clear();
    loaded = false;
}
//# sourceMappingURL=translationMapper.js.map